let mixin = {
  data () {
    return {
      PAGINATION: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      }
    }
  }
}
export default mixin
